module.exports = __webpack_public_path__ + "static/media/EU_logo2.9bc8b56e.svg";